import React from 'react';

const TagPill_1 = ({ iconName, caption, tagLevel, bgColors }) => {
     let level1TagOptions = `text-xs ${bgColors || 'bg-gray-200 dark:bg-slate-800'} dark:text-gray-400`
     let level2TagOptions = `text-xs ${bgColors || 'bg-gray-200 dark:bg-slate-800'} dark:text-gray-400 border-gray-300`

     return (
     <span className={`inline-table items-center rounded px-3 py-1 mr-0.5 font-ubuntu 
          ${tagLevel === 1 ? level1TagOptions : level2TagOptions}`} >
          {iconName ? 
               <i className={`devicon-${iconName}-plain colored mr-3 text-sm align-middle`} style={{width:'10px'}}></i> 
               :
               <i className=""></i>
          }
            {caption}
       </span>
);}

export default TagPill_1